import { getParents } from '.';
import constantes from '../resources/constantes.json';

function findFirstElection(busquedaItem) {
  return busquedaItem.r.findIndex((number) => { return number !== -1 })
}

export const getDataFavoritos = ({
  busquedaItem, //{"i": 167,"n": "CABRERA","c": "15029","s": "CABRERA","l": 3,"p": [14],"r": [168,167,168,167,-1,169],"h": []}
  nomenclator,
  page,
  currentElection = undefined
}) => {

  const isInicio = page === 'inicio'
  let electionIndex = findFirstElection(busquedaItem);
  let electionCode = nomenclator.ordAmbitos[electionIndex];

  if (isInicio) {
    electionIndex = busquedaItem.r.length - 1;
    electionCode = constantes.eleccion.inicio
  } else if (currentElection) {
    const currentElectionIndex = nomenclator.ordAmbitos.findIndex((amb) => { return amb === currentElection })
    const currentElectionR = busquedaItem.r[currentElectionIndex]
    if (currentElectionR >= 0) {
      electionIndex = currentElectionIndex
      electionCode = currentElection
    }
  }

  const urlElectionName = constantes.nombreEleccion[electionCode]
  const idRuta = busquedaItem.r[electionIndex];
  const genealogy = [idRuta, ...getParents(idRuta, electionCode, nomenclator, busquedaItem.l)];
  const genealogyNames = genealogy.map((item) => { return nomenclator.ambitos[electionCode][item].s.toLowerCase() })
  return {
    url: `/${urlElectionName}/${idRuta}/${genealogyNames.reverse().join('/')}`,
    genealogyNames
  }

};

export default getDataFavoritos;
